export const dictionary = {
  CREATE_TITLE: {
    ES: "Crear categoría",
    EN: "Create category",
  },
  UPDATE_TITLE: {
    ES: "Actualizar categoría",
    EN: "Update category",
  },
  TITLE: {
    ES: "Tus categorías",
    EN: "Your categories",
  },
  CATEGORY_TITLE: {
    ES: "Título de la categoría",
    EN: "Category title",
  },
  CARD_TYPE: {
    ES: "Tamaño de tarjeta",
    EN: "Card type",
  },

  NORMAL_CARD: {
    ES: "Normal",
    EN: "Normal",
  },
  SMALL_CARD: {
    ES: "Pequeña",
    EN: "Small",
  },
  PRODUCT_LIST_TITLE: {
    ES: "Productos seleccionados",
    EN: "Products selected",
  },
  ADD_PRODUCT: {
    ES: "Agregar producto",
    EN: "Add product",
  },
  REMOVE_CONFIRM: {
    ES: "¿Estás seguro que deseas eliminar esta categoría? \n No podrás recuperarla.",
    EN: "Are you sure you want to delete this category? \n  You won't be able to recover it.",
  },
  EMPTY_LIST: {
    ES: "Aún no tienes categorías",
    EN : "No categories yet"
  }
} as const;
